import dayjs from "dayjs";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import PageHeader from "../../Component/Common/PageHeader";
import PageContainer from "../../Component/Common/Page";
import MultiButton from "../../Component/extra/MultiButton";
import WithDrawRequest from "./WithDrawRequest";
import AcceptedRequest from "./AcceptedRequest";
import DeclinedRequest from "./DeclinedRequest";
import WithDrawDetails from "./WithDrawDetails";

const ManageWithDraw = () => {
  const { dialogueType } = useSelector((state) => state.dialogue);

  const [multiButtonSelect, setMultiButtonSelect] = useState("Pending");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  return (
    <PageContainer>
      <PageHeader
        heading={"Welcome Admin"}
        subHeading={"Withdrawal Request"}
        showDateRange={true}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <MultiButton
        label={["Pending", "Accepted", "Declined"]}
        setMultiButtonSelect={setMultiButtonSelect}
        multiButtonSelect={multiButtonSelect}
      />

      {multiButtonSelect == "Pending" && (
        <WithDrawRequest
          endDate={endDateData}
          startDate={startDateData}
          multiButtonSelectNavigate={setMultiButtonSelect}
        />
      )}
      {multiButtonSelect == "Accepted" && (
        <AcceptedRequest endDate={endDateData} startDate={startDateData} />
      )}
      {multiButtonSelect == "Declined" && (
        <DeclinedRequest endDate={endDateData} startDate={startDateData} />
      )}
      {dialogueType === "pay" && <WithDrawDetails />}
    </PageContainer>
  );
};

export default ManageWithDraw;
